import React, {Suspense, Component, lazy} from 'react';
import {createBrowserHistory} from 'history';
import {Route, Router, Switch} from 'react-router-dom';

import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min';
import 'uikit/dist/js/uikit-icons';
import './App.css';

const Home = lazy(() => import('../Home/Home'));
const Project = lazy(() => import('../Project/Project'));
const Contact = lazy(() => import('../Contact/Contact'));

const history = createBrowserHistory();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: true
    }
  }
  render() {
    return (
      <Router history={history}>
        <Suspense fallback={<div></div>}>
          <Switch>
            <Route exact path="/" render={(props) => <Home {...props} />}/>
            <Route exact path="/contact" render={(props) => <Contact {...props} />}/>
            <Route exact path={["/project/:project_name"]} render={(props) => <Project {...props} />} />
          </Switch>
        </Suspense>
      </Router>
    )
  }
}

export default App;
